<template>
  <!-- 器械明细 -->
  <el-dialog
    :title="`器械内容`"
    :width="pda.status? '90%' : '1000px'"
    :show-close="false"
    :visible.sync="show"
    :close-on-click-modal="false"
  >
    <el-table
      border
      :data="list"
    >
      <el-table-column
        label="#"
        type="index">
      </el-table-column>
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        width="auto">
        <template slot-scope="scope">
          <span v-if="item.prop === 'image'">
            <span v-for="(i, index) in scope.row.image" :key="index" style="width: 40px;height: 40px;overflow: hidden;display:inline-block;">
              <el-image class="cover" :src="i.url || defaultImg" :preview-src-list="(scope.row.image ? scope.row.image : []).map(s => s.url)"></el-image>
            </span>
          </span>
          <span v-else-if="item.prop === 'handle'">
            <!-- 删除udi -->
            <el-button v-show="scope.row.udi" type="primary" size="small" @click="delUdi(scope.row)">
              删除udi
            </el-button>
          </span>
          <span v-else>
            {{scope.row[item.prop]}}
          </span>
        </template>
      </el-table-column>
      </el-table>

      <div class="d-flex right mt10">
        <!-- 关闭 -->
        <el-button size="small" @click="close()">关闭 </el-button>
      </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { CodeInstrumentSetDetail, checkUdiBindCodeInstrumentsetStatus, codeInstrumentSetBindUdi, codeInstrumentSetUnbindUdi } from '@/api.js'
export default {
  name: 'BasicInstrumentDetail',
  data() {
    return {
      show: false,
      columns: [
        {
          prop: "name",
          label: "物品名"
        },
        {
          prop: "specification",
          label: "规格型号"
        },
        {
          prop: "number",
          label: "数量"
        },
        {
          prop: "image",
          label: "图片"
        },
        {
          prop: "udi",
          label: "udi"
        },
        {
          prop: "handle",
          label: "操作"
        }
      ],
      code: 0,
      list: []
    }
  },
  computed: {
    ...mapGetters(['pda'])
  },
  methods: {
    open(code) {
      // 打开弹窗
      if (!code) return
      this.code = code
      this.getDetail()
      this.show = true
    },
    getDetail() {
      // 获取详情
      const url = CodeInstrumentSetDetail.replace('{code}', this.code)
      this.$request('get', url)
      .then(res => {
        if (res) {
          const { instrument } = res
          this.list = instrument || []
        }
      })
    },
    checkUdi(udi) {
      // 检查udi绑定状态
      const params = {
        udi,
        inner_code: this.code
      }

      return this.$request('post', checkUdiBindCodeInstrumentsetStatus, params)
      .then(res => !!res)
    },
    bindUdi(udi = []) {
      // 绑定udi
      const url = codeInstrumentSetBindUdi.replace('{code}', this.code)
      const params = {
        udi_data: udi.map(i => {
          return {
            udi: i
          }
        })
      }

      return this.$request('post', url, params)
      .then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.getDetail()
        }
      })
    },
    delUdi(item) {
      // 删除udi
      const { instrument_id, udi } = item
      const params = {
        udi_data: [
          {
            instrument_id,
            udi
          }
        ]
      }
      const url = codeInstrumentSetUnbindUdi.replace('{code}', this.code)

      this.$request('post', url, params)
      .then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.getDetail()
        }
      })
    },
    close() {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>

<style>

</style>